import { useAuthStore } from "@/stores/auth";
import { NO_LINE_AUTH_PATHS, matchesPath } from "@/utils/authPaths";

export default defineNuxtPlugin(async () => {
  const config = useRuntimeConfig();
  const auth = useAuthStore();

  const liffId = config.public.LIFF_ID as string;
  if (!liffId) {
    console.error("[liff] LIFF_ID missing in runtimeConfig.public");
    return;
  }

  // ⚠️ LIFF SDK จะ rewrite URL ตอน init (history.replaceState) — strip query params บางตัวออก
  // capture URL search ดิบไว้ใน sessionStorage ก่อน เพื่อให้ page อื่นอ่าน fallback ได้
  if (typeof window !== "undefined" && window.location.search) {
    sessionStorage.setItem("__entry_query", window.location.search);
  }

  // 🚪 หน้า no-login (desktop mode) → ข้าม liff.init ทั้งหมด ไม่ยุ่งกับ LINE SDK เลย
  // เช็ก window.location.pathname (entry path ดิบ) ก่อน liff.init จะไป rewrite URL
  if (matchesPath(NO_LINE_AUTH_PATHS, window.location.pathname)) {
    return;
  }

  const host = window.location.hostname;
  const useMock = host === "localhost" || host === "127.0.0.1";

  await auth.init(liffId, { mock: useMock });
});
